export default "__VITE_ASSET__XCbldpSx__"